import React from "react";
import Link from "gatsby-link";
import Icon from "../Icon";

const BackBannerBio = () => {
  return (
    <div className="banner--back flex flex-column w-100 mw-1060">
      <Link
        to="/about-us/our-staff/"
        className="banner--back__link flex items-center justify-center grey1 ttu pv1 pBio-l w-100"
      >
        <Icon
          path="arrow-left"
          width="32"
          height="18"
          className="banner--back__icon flex items-center"
        />
        <p className="ml1 mb0 h-5">Our Staff</p>
      </Link>
    </div>
  );
};

export default BackBannerBio;



// WEBPACK FOOTER //
// ./src/components/Banners/BackBannerBio.js